module.exports = __webpack_public_path__ + "img/natural-health.873884c9.svg";